// removed by extract-text-webpack-plugin
module.exports = {"councilPage":"council-page-module__councilPage___3JGJo","buttonsRow":"council-page-module__buttonsRow___2lLlG","backLinkImage":"council-page-module__backLinkImage___2Ly2B","backLink":"council-page-module__backLink___G2tvl","mapsRow":"council-page-module__mapsRow___1BXb_","noDataNotice":"council-page-module__noDataNotice___2G69s","noDataNoticeHeading":"council-page-module__noDataNoticeHeading___e3rVi","compareButton":"council-page-module__compareButton___1xrEN"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/council-page/council-page.module.scss
// module id = 695
// module chunks = 0 1